import { EditorialCard, EditorialCardMutation } from '../features/editorial-cards/types/EditorialCard'
import { internalFeedApi } from './internal-feed'

// Legacy's range: from 2016-09-01 to ten years ahead, so scheduled cards are listed too.
export const EDITORIAL_CARDS_BEGIN = 1472688000000
const TEN_YEARS_MS = 10 * 365.25 * 24 * 60 * 60 * 1000

const editorialCardsApi = internalFeedApi.enhanceEndpoints({ addTagTypes: ['internalEditorialCards'] }).injectEndpoints({
  endpoints: (builder) => ({
    getEditorialCards: builder.query<EditorialCard[], void>({
      query: () => ({ url: 'i/entries/editorial/list', params: { begin: EDITORIAL_CARDS_BEGIN, end: Math.round(Date.now() + TEN_YEARS_MS) } }),
      providesTags: ['internalEditorialCards'],
    }),
    getEditorialCard: builder.query<EditorialCard, string>({
      query: (id) => `i/entries/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'internalEditorialCards', id }],
    }),
    saveEditorialCard: builder.mutation<EditorialCard, EditorialCardMutation>({
      query: (card) => ({ url: 'i/entries', method: 'PUT', body: card }),
      invalidatesTags: ['internalEditorialCards'],
    }),
    deleteEditorialCard: builder.mutation<string, string>({
      query: (id) => ({ url: `i/entries/editorial/${id}`, method: 'DELETE', responseHandler: 'text' }),
      // Not the list: the page refetches it to confirm the delete, and a refetch started by invalidation
      // makes that refetch resolve right away with the list from before the delete.
      invalidatesTags: (_result, _error, id) => [{ type: 'internalEditorialCards', id }],
    }),
  }),
})

export const { useGetEditorialCardsQuery, useGetEditorialCardQuery, useSaveEditorialCardMutation, useDeleteEditorialCardMutation } = editorialCardsApi
